export enum ResizeTypeModel {
    OPEN, CLOSE
}

export class ResizeModel {
    type: ResizeTypeModel;
    width: number;
    minWidth?:number;
    maxWidth?:number;
}
